import { render, staticRenderFns } from "./CommonDrawer1Old.vue?vue&type=template&id=2fd4bc91&scoped=true"
import script from "./CommonDrawer1Old.vue?vue&type=script&lang=js"
export * from "./CommonDrawer1Old.vue?vue&type=script&lang=js"
import style0 from "./CommonDrawer1Old.vue?vue&type=style&index=0&id=2fd4bc91&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd4bc91",
  null
  
)

export default component.exports